import request from '@/utils/request'


/**
 *获得日历代办内容
 * @returns {*}
 */
export function getCalendarAgentList(data) {
  return request({
    url: '/api/v2/user_processes/processes_info/get_calendar_agent_list',
    method: 'post',
    params: data
  })
}


/**
 *获得进度详情
 * @returns {*}
 */
export function getUserProcessInfo(data) {
  return request({
    url: '/api/v2/user_processes/processes_info/get_user_process_info',
    method: 'post',
    params: data
  })
}

/**
 * 获得材料清单
 * @returns {*}
 */
export function getBillOfMaterials(data) {
  return request({
    url: '/api/v2/user_processes/processes_info/get_bill_of_materials',
    method: 'get',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/api/overview.js